module.exports = __webpack_public_path__ + "static/media/pulse.dc5cec02.png";